import * as tslib_1 from "tslib";
import { OnInit, Renderer2 } from '@angular/core';
import { LoginModel } from 'src/app/models/accounts/login.model';
import { BasePageComponent } from 'src/app/modules/core/components/bases/base-page-component';
import { AppTokens } from 'src/app/models/authentications/access-token.model';
export class LoginComponent extends BasePageComponent {
    constructor(userService, request, auth, router, route, spinnerService, renderer, titleService) {
        super();
        this.userService = userService;
        this.request = request;
        this.auth = auth;
        this.router = router;
        this.route = route;
        this.spinnerService = spinnerService;
        this.renderer = renderer;
        this.titleService = titleService;
        this.model = new LoginModel();
        this.disabled = false;
        this.isLoad = false;
    }
    ngOnInit() {
        this.titleService.setTitle('Backend – TROFACO');
        this.spinnerService.setupShowOnBodyUntil(this.renderer, this.onDestroy$);
    }
    onLogin() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.model.isModelValid()) {
                this.loading();
                try {
                    const res = yield this.request.formPost("authentication/login" /* Login */, this.model.toFormData(), { retryOn401: false });
                    const tokens = new AppTokens(res);
                    this.auth.saveToken(tokens);
                    yield this.loadCurrentUser();
                    let url = this.auth.getRedirectToFromQueryParams(this.route.snapshot.queryParams);
                    yield this.router.navigateByUrl(url);
                }
                catch (err) {
                    this.onError();
                    throw err;
                }
            }
        });
    }
    loadCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.userService.getCurrentUserAsync();
        });
    }
    loading() {
        this.model.isFail = true;
        this.isLoad = true;
        this.disableForm();
    }
    onError() {
        this.model.isFail = false;
        this.enableFrom();
    }
    disableForm() {
        this.disabled = true;
    }
    enableFrom() {
        this.isLoad = false;
        this.disabled = false;
    }
}
